import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const December = () => {
    return (
        <Fragment>{SkipDays(2, 4, [])}</Fragment>  
    )
}